import { Arrange, IconButton, Spacer, SvgClose, Text } from '@loomhq/lens';
import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { hideConfirmationModal } from 'actions/confirmationModal';

import './styles.less';

const MODAL_TRANSITION_TIMEOUT = 300;

const TIMER_TIMEOUT = 3000;

const ConfirmationModal = class extends Component {
  render() {
    const { message, show, severity } = this.props;

    let confirmationModal = null;

    if (show) {
      const modalClass = classNames('confirmation-modal', severity);

      confirmationModal = (
        <div className={modalClass}>
          <Spacer top="small" right="small" bottom="small" left="medium">
            <Arrange justifyContent="space-between" gap="small">
              <Text color="white">{message}</Text>
              <IconButton
                altText="Close"
                icon={<SvgClose />}
                iconColor="white"
                onClick={this.props.hideConfirmationModal}
              />
            </Arrange>
          </Spacer>
        </div>
      );
    }

    return (
      <CSSTransitionGroup
        transitionName="confirmation-modal"
        transitionEnterTimeout={MODAL_TRANSITION_TIMEOUT}
        transitionLeaveTimeout={MODAL_TRANSITION_TIMEOUT}
      >
        {confirmationModal}
      </CSSTransitionGroup>
    );
  }

  componentDidMount() {
    this.timerCountdown(false, this.props.timerTimeout);
  }

  componentDidUpdate(prevProps) {
    const { message, timerTimeout } = this.props;

    if (prevProps.message !== message) {
      this.timerCountdown(true, timerTimeout);
    } else {
      this.timerCountdown(false, timerTimeout);
    }
  }

  timerCountdown(clear = false, timerTimeout) {
    const { show } = this.props;

    if (!show) {
      return;
    }

    if (clear && this.timeoutID) {
      window.clearTimeout(this.timeoutID);
      this.timeoutID = 0;
    }

    this.timeoutID = window.setTimeout(() => {
      this.props.hideConfirmationModal();
    }, timerTimeout || TIMER_TIMEOUT);
  }
};

const mapStateToProps = state => {
  const { message, show, severity, timerTimeout } = state.confirmation_modal;

  return { message, show, severity, timerTimeout };
};

const mapDispatchToProps = dispatch => {
  return {
    hideConfirmationModal: () => dispatch(hideConfirmationModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
